<div class="dialog-content">
  <h2>掃碼狀態：{{ state }}</h2>

  <div *ngIf="state === 'Waiting'">
    請點擊掃描器並開始掃碼。
  </div>
  <div *ngIf="state === 'Processing'">
    條碼輸入中，請勿操作鍵盤...
  </div>
  <div *ngIf="state === 'Done'">
    條碼已讀取完成。
  </div>
  <mat-checkbox [(ngModel)]="isManual">手動輸入</mat-checkbox>
  <div class="input-section" *ngIf="isManual">
    <label for="barcodeInput">手動輸入條碼：</label>
    <textarea
      id="barcodeInput"
      type="text"
      [(ngModel)]="barcodeInput"
      placeholder="請輸入條碼"
      style="width: 100%; height: 300px; font-size: 12px; padding: 10px; resize: none;"></textarea>
    <button (click)="submitManualInput()">送出</button>
  </div>
</div>
